import { AuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdminGuard } from './guards/admin.guard';
import { WriterGuard } from './guards/writer.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { MenuItem } from './shared/components/sidebar-nav/sidebar-nav.dto';
import { ChimeMeetingPageComponent } from './shared/components/video-call-drawer-chime/chime-meeting-page/chime-meeting-page.component';
import { ConfirmUserAccountComponent } from './views/confirm-user-account/confirm-user-account.component';
import { CoursesRoutes } from './views/displayer/courses/courses.routing';
import { NoteRoutes } from './views/displayer/notes/notes-routing';
import { GroupRoutes } from './views/groups/group-routing';
import { LoginComponent } from './views/login/login.component';
import { QuestionsComponent } from './views/questions/questions.component';
import { SigninComponent } from './views/signin/signin.component';
import { SignupComponent } from './views/signup/signup.component';
import { JoinComponent } from './views/join/join.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['home']);
const authGuardPipeWithInviteCheck = (next: ActivatedRouteSnapshot) => pipe(
  map((user: any) => {
    if (user && !next.queryParams['invite']) {
      return ['home'];
    }
    return true;
  })
);

export const mainRouteMenuItems: MenuItem[] = [
  {
    value: 'knowledge',
    view: 'Home.Header.CourseButton',
    link: '/knowledge',
    icon: 'menu_book',
    isSvgIcon: false,
  },
  {
    value: 'notes',
    view: 'Home.Header.NoteButton',
    link: '/notes',
    icon: 'edit_note',
    isSvgIcon: false,
    writerOnly: true,
  },
  {
    value: 'my-models',
    view: 'MySpace.MyModels',
    link: '/myspace/my-models',
    icon: 'network_intel_node',
    isSvgIcon: false,
    writerOnly: true,
  },

  {
    value: 'groups',
    view: 'Home.Header.Groups',
    link: '/groups',
    icon: 'group',
    isSvgIcon: false,
    adminOnly: true,
  },
  // {
  //   value: 'search',
  //   view: 'Home.Header.Search',
  //   link: '/search',
  //   icon: 'document_search',
  //   isSvgIcon: false,
  // },
  // {
  //   value: 'questions',
  //   view: 'Home.Header.Questions',
  //   link: '/questions',
  //   icon: 'person_raised_hand',
  //   isSvgIcon: false,
  //   writerOnly: true,
  // },
];

export const appRoutes: Routes = [
  {
    path: 'signin',
    component: SigninComponent,
    canActivate: [AuthGuard],
    data: { authGuardPipe: authGuardPipeWithInviteCheck },
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome },
  },
  {
    path: 'signup',
    component: SignupComponent,
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome },
  },
  {
    path: 'join/:token',
    component: JoinComponent,
  },
  { path: 'video-call/:id', component: ChimeMeetingPageComponent },
  { path: 'confirm', component: ConfirmUserAccountComponent },
  {
    path: 'shared/:tenantId/:shareToken',
    loadComponent: () => import('./views/displayer/courses/public-displayer/public-displayer.component').then((m) => m.PublicDisplayerComponent),
  },
  {
    path: 'shared/:tenantId/:shareToken/:section/:lecture',
    loadComponent: () => import('./views/displayer/courses/public-displayer/public-displayer.component').then((m) => m.PublicDisplayerComponent),
  },
  { path: 'video-call/:id', component: ChimeMeetingPageComponent, canActivate: [AuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      { path: 'home', redirectTo: 'knowledge', pathMatch: 'full' },
      { path: 'knowledge', children: CoursesRoutes },
      { path: 'myspace', loadChildren: () => import('./views/my-space/my-space.module').then((m) => m.MySpaceModule) },
      { path: 'groups', children: GroupRoutes, canActivate: [AdminGuard] },
      { path: 'notes', children: NoteRoutes, canActivate: [WriterGuard] },
      { path: 'questions', component: QuestionsComponent, canActivate: [WriterGuard] },
      { path: 'tutorials', loadComponent: () => import('./views/tutorials/tutorials.component').then((m) => m.TutorialsComponent) },
      // { path: 'search', component: SearchComponent },
      { path: 'checkout-success', redirectTo: 'knowledge', pathMatch: 'full' },
      { path: '', redirectTo: 'knowledge', pathMatch: 'full' },
    ],
  },
];
